import React, { Component } from 'react';
import ContentEditable from 'react-contenteditable'
import './TranscriptEditor.css';
import Utility from '../../../Utility';
import { connect } from 'react-redux';

import { ReactComponent as IconPlay } from './TranscriptIcons/play.svg';

const _ = require('lodash');

const MAX_CHAR_LINE_LENGTH = 32;
const MAX_GAP_TIME = .2;
// const SCROLL_PADDING_PERCENT = .5;

class TranscriptEditor extends Component {
	constructor(props) {
		super(props);

		this.state = {
			lines: [],
			searchText: '',
			reviewed: this.props.data.recording.info.words_reviewed ? true : false, // If this isn't set this way, react thinks the component is uncontrolled
			cid: this.props.data.recording.info.cid,
			edited: false,
			autoPlay: true
		}

		if (this.props.data.lines.length > 0) {
			this.state.lines = this.props.data.lines;
			this.state.edited = true;
		} else {
			// Parse the words array
			var lineIndex = 0,
				join = true,
				prevEnd = 0,
				words = this.props.data.recording.info.words,
				word = {};

			for (var i = 0; i < words.length; i++) {
				join = true;
				word = words[i];

				// compare two things - line length, and time between words
				if (this.state.lines[lineIndex] && (this.state.lines[lineIndex].line.length + 1 + word.word.length) > MAX_CHAR_LINE_LENGTH) {
					join = false;
				}

				if (this.state.lines[lineIndex] && word.start_time - prevEnd > MAX_GAP_TIME) {
					join = false;
				}

				if (join === false) {
					// Start a new line
					lineIndex++;
				}

				if (!this.state.lines[lineIndex]) {
					this.state.lines[lineIndex] = {
						line: word.word,
						start_time: word.start_time,
						end_time: word.end_time,
						length: word.end_time - word.start_time,
						key: lineIndex,
						originalWords: [ word ],
						edited: false
					};
				} else {
					// append
					this.state.lines[lineIndex].line += ' ' + word.word;
					this.state.lines[lineIndex].end_time = word.end_time;
					this.state.lines[lineIndex].length = word.end_time - this.state.lines[lineIndex].start_time
					this.state.lines[lineIndex].originalWords.push(word);
				}

				prevEnd = word.end_time;
			}
		}

		this.currentCaption = -1;
		this.keyPrefix = 1;

		this.startIndex = 0;
		this.endIndex = 40;

		this.resumePlayingTID = false;

		this.pauseAtTime = false;
		this.reallyDoPause = false;

		this.evalVisibleWords = _.debounce(this.evalVisibleWords, 50);
	}

	onscrollHandler = (ev) => {
		this.evalVisibleWords();
	}

	componentDidUpdate() {

		/* This is a really weird set of conditions - so I should explain.
			When we set pauseAtTime, it is possible the currentTime is already > the pauseAtTime since we may be going *back* in time
			So we should only attempt to pause once we know we are before the pauseAtTime
		*/
		if (this.pauseAtTime !== false && !this.reallyDoPause && this.props.dynamic.currentTime < this.pauseAtTime) {
			this.reallyDoPause = true;
		}

		if (this.pauseAtTime !== false && this.reallyDoPause && this.props.dynamic.currentTime > this.pauseAtTime) {
			this.props.trigger('pause');
			this.pauseAtTime = false;
			this.reallyDoPause = false;
		}
	}

	onchangeHandler = (ev) => {
		this.setState({ searchText: ev.target.value });
	}

	lineUpdateRequest = (request) => {
		var targetIndex = request.index;

		var lines = JSON.parse(JSON.stringify(this.state.lines));

		switch(request.type) {
			case 'line_change':
				lines[targetIndex].line = request.newLine;
				lines[targetIndex].edited = true;
				this.setState({
					lines: lines,
					edited: true
				}, () => { this.forceUpdate(); });

				this.props.updatePlayerState({
					lines: lines
				});

				// Save to local storage
				Utility.localStorageSet(this.props.data.recording.recordingkey + '.lines', JSON.stringify(lines), true);
				Utility.localStorageSet(this.props.data.recording.recordingkey + '.wordHash', this.props.data.wordChecksum, true);

				break;
			default:
				console.log(request);
		}
	}

	evalVisibleWords = () => {
		/*
		if (this.editorRef.current) {
			var words = this.state.words;

			var padding = this.editorRef.current.offsetWidth * SCROLL_PADDING_PERCENT,
				start_time = Math.max(0, this.editorRef.current.scrollLeft - padding) / PIXELS_PER_SECOND,
				end_time = (this.editorRef.current.scrollLeft + this.editorRef.current.offsetWidth + padding) / PIXELS_PER_SECOND,
				start_index = null,
				end_index = null;

			for (var i = 0; i < words.length; i++) {
				if (words[i].start_time > start_time && words[i].end_time < end_time) {
					if (start_index === null) {
						start_index = i;
					}

					end_index = i;
				}
			}

			if (start_index === null) {
				start_index = 0;
			}

			if (end_index === null) {
				end_index = start_index + 40;
			}

			// If we don't do this, then huge gaps will prevent the next word from being rendered, and tabbing to it will fail
			start_index = Math.max(start_index-1, 0);
			end_index = Math.min(end_index+1, words.length-1);

			if (this.startIndex !== start_index || this.endIndex !== end_index) {
				this.startIndex = start_index;
				this.endIndex = end_index;
				this.forceUpdate();
			}
		}
		*/
	}

	saveLines = (ev) => {
		// ok...
		this.props.updatePlayerState({
			showSavingLineEditsModal: true
		});

		Utility.callApiPost('save_lines', { lines: this.state.lines, reviewed: this.state.reviewed, cid: this.state.cid }, this.processResponse);
	}

	processResponse = (response) => {
		response = JSON.parse(response.response);

		if (response.error) {
			alert('failed to save transcript');
		} else {
			// Reset our transcript and associated things
			var recording = this.props.data.recording;

			// Clear out any saved edits
			Utility.localStorageRemove(this.props.data.recording.recordingkey + '.lines');
			Utility.localStorageRemove(this.props.data.recording.recordingkey + '.wordHash');

			recording.info.captions = response.captions;
			recording.info.words = response.words;
			recording.info.words_reviewed = response.words_reviewed;

			var wordChecksum = Utility.checksum(JSON.stringify(response.words));

			this.props.updatePlayerState({
				showSavingLineEditsModal: false,
				wordChecksum: wordChecksum,
				recording: recording,
				lines: []
			}, this.resetFromProps);
		}
	}

	resetFromProps = () => {
		console.log('resetFromProps');
		var stateLines = [];

		// Parse the words array
		var lineIndex = 0,
			join = true,
			prevEnd = 0,
			words = this.props.data.recording.info.words,
			word = {};

		for (var i = 0; i < words.length; i++) {
			join = true;
			word = words[i];

			// compare two things - line length, and time between words
			if (stateLines[lineIndex] && (stateLines[lineIndex].line.length + 1 + word.word.length) > MAX_CHAR_LINE_LENGTH) {
				join = false;
			}

			if (stateLines[lineIndex] && word.start_time - prevEnd > MAX_GAP_TIME) {
				join = false;
			}

			if (join === false) {
				// Start a new line
				lineIndex++;
			}

			if (!stateLines[lineIndex]) {
				stateLines[lineIndex] = {
					line: word.word,
					start_time: word.start_time,
					end_time: word.end_time,
					length: word.end_time - word.start_time,
					key: lineIndex,
					originalWords: [ word ],
					edited: false
				};
			} else {
				// append
				stateLines[lineIndex].line += ' ' + word.word;
				stateLines[lineIndex].end_time = word.end_time;
				stateLines[lineIndex].length = word.end_time - stateLines[lineIndex].start_time
				stateLines[lineIndex].originalWords.push(word);
			}

			prevEnd = word.end_time;
		}

		this.setState({
			lines: stateLines,
			reviewed: this.props.data.recording.info.words_reviewed ? true : false, // If this isn't set this way, react thinks the component is uncontrolled
			edited: false
		});

		this.currentCaption = -1;
		this.keyPrefix++;
	}

	editingLine = (lineIndex) => {
		console.log('editing line:', lineIndex);
	}

	handleReviewedChange = (ev) => {
		this.setState({
			reviewed: ev.target.checked,
			edited: true
		});
    }

	cancelAutoplay = () => {
		this.pauseAtTime = false;
		this.reallyDoPause = false;

		if (this.resumePlayingTID) {
			clearTimeout(this.resumePlayingTID);
		}
	}

	playThisLine = (originalIndex, kind) => {
		this.cancelAutoplay();

		var time = this.state.lines[originalIndex].start_time,
			end_time = false;

		if (this.state.lines[originalIndex+2]) {
			// always play to the end of the next line
			end_time = this.state.lines[originalIndex+2].end_time;
		}

		// Play button next to line is clicked - this should always start playing at this position no matter what
		if (kind === 'forced') {
			this.props.trigger('seek', time);
			this.pauseAtTime = end_time;
		}

		// The rest should only take effect if aytoPlay is enabled
		if (this.state.autoPlay) {
			// two other kinds - `change` and `focus`

			// `change` should include a delay, and end time should move
			if (kind === 'change') {
				end_time = this.props.dynamic.currentTime + 5; // pause 5 seconds from where the current playback head is

				this.resumePlayingTID = Utility.delay(800, () => {
					this.pauseAtTime = end_time;
					this.props.trigger('play');
				}, this);
			}

			if (kind === 'keydown') {
				this.resumePlayingTID = Utility.delay(400, () => {
					this.props.trigger('play');
				}, this);
			}

			// `focus` should trigger immediatly (like forced)
			if (kind === 'focus') {
				// This is the difficult one
				if (this.props.data.paused === true) {
					// If paused, start playing on this line
					this.props.trigger('seek', time);
					this.pauseAtTime = end_time;
				} else {
					// If playing, look at where the playback head is relative to the start of the line and the end of the next line
					if (time > this.props.dynamic.currentTime) {
						// Always jump when we click into a future time
						this.props.trigger('seek', time);
						this.pauseAtTime = end_time;
					} else if (time < this.props.dynamic.currentTime && end_time > this.props.dynamic.currentTime) {
						// we are between the end time so push to the end of next line but don't jump
						this.pauseAtTime = end_time;
					} else if (time < this.props.dynamic.currentTime && end_time < this.props.dynamic.currentTime) {
						// we've focused on an earlier time, so seek to it
						this.props.trigger('seek', time);
						this.pauseAtTime = end_time;
					}
				}
			}
		}
	}

	pauseThisLine = () => {
		if (this.state.autoPlay) {
			this.cancelAutoplay();
			this.props.trigger('pause');
		}
	}

	toggleAutoPlay = (ev) => {
		this.setState({ autoPlay: !this.state.autoPlay });
	}

	render() {
		var searchWords = this.state.searchText.split(' ').map((word) => {
			return word.toLowerCase();
		});

		var auoPlayButtonClass = this.state.autoPlay ? 'on' : 'off';

		return (
			<div className="transcript-editor">
				<h2 className="visuallyhidden">Transcript Editor</h2>
				<div className="toolbar">
					{/*<input type="text" placeholder="Search lines" value={this.state.searchText} onChange={this.onchangeHandler} />*/}
					<div className="checkbox-wrap"><label><input type="checkbox" name="reviewed" checked={this.state.reviewed} onChange={this.handleReviewedChange} /> Reviewed</label></div>
					<button onClick={this.toggleAutoPlay} className={auoPlayButtonClass}>Autoplay is {auoPlayButtonClass}</button>
					{ this.state.edited ? <button onClick={this.saveLines}>Save</button> : null }
				</div>
				<div className="transcript-scroller" onScroll={this.onscrollHandler}>
					{ this.state.lines.filter((line, index) => {
						if (searchWords.length > 0) {
							for (var i = searchWords.length - 1; i >= 0; i--) {
								if (!line.line.toLowerCase().includes(searchWords[i])) {
									return false;
								}
							}
						}

						return true;
					}).map((line, index) => {
						return <LineRow originalIndex={line.key} playhere={this.playThisLine} pausehere={this.pauseThisLine} cancelAutoplay={this.cancelAutoplay} editing={this.editingLine} updatebroker={this.lineUpdateRequest} trigger={this.props.trigger} key={this.keyPrefix + '_' + line.key} lineindex={index} line={line} />
					})}
				</div>
			</div>
		);
	}
}

class LineRow extends React.PureComponent {
	constructor(props) {
		super(props);

    	this.state = {
    		html: this.props.line.line
    	};

    	this.allowSaving = true;
	}

	handleChange = (ev) => {
		this.setState({html: ev.target.value});

		this.props.pausehere();
		this.props.playhere(this.props.originalIndex, 'change');
	};

	keyDownHandler = (ev) => {
		switch (ev.keyCode) {
			case 37: // 37: ←
			case 39: // 37: →
			case 38: // 38: ↑
			case 40: // 40: ↓
				this.props.pausehere();
				this.props.playhere(this.props.originalIndex, 'keydown');
				break;
			default:
				// do nothing
		}
	}

	onfocusHandler = (ev) => {
		this.props.playhere(this.props.originalIndex, 'focus');
	}

	onblurHandler = (ev) => {
		// lost focus
		if (this.allowSaving === true && this.state.html.trim() !== this.props.line.line) {
			// Remove any &nbsp; character - Chrome generates these when there is a space
			// at the end of the line or if there are multiple spaces next to one another
			var line = this.state.html.replace(/&nbsp;/g, ' ');
			line = line.replace(/<br>/g, ' '); // Safari adds line breaks when the line is cleared
			line = line.replace(/ {2}/g, ' ');
			line = line.trim();

			this.setState({
				html: line
			});

			this.props.updatebroker({
				type: 'line_change',
				index: this.props.lineindex,
				newLine: line
			});
		}

		this.allowSaving = true;
	}

	jumpToLine = (ev) => {
		this.props.playhere(this.props.originalIndex, 'forced');
	}

	render() {
		var rowClass = 'transcript-row';

		if (this.props.active) {
			rowClass += ' active';
		}

		if (this.props.line.edited) {
			rowClass += ' edited';
		}

		return (
			<div className={rowClass}>
				<div className="transcript-play">
					<button onClick={this.jumpToLine}><IconPlay /></button>
				</div>
				<div className="transcript-text">
					<ContentEditable
						tabIndex={(this.props.lineindex + 1000)}
						className="editable-line"
						onBlur={this.onblurHandler}
						onFocus={this.onfocusHandler}
						html={this.state.html}
						onChange={this.handleChange}
						onKeyDown={this.keyDownHandler}
		            />
				</div>
			</div>
		);
	}
}

const mapStateToProps = (state) => ({
	dynamic: state.dynamic,
});

export default connect(mapStateToProps)(TranscriptEditor);